import { useState, useEffect } from 'react';
import { Flex, Alert, Card, Text } from '@smarterservices/smarter-ui';
import Chat from './Chat';
import CONSTANTS from '../../../config/constants';
import {
  useLayoutStore,
  useExamSessionStore,
  getStore,
} from '../../../stores/StoreContext';

const Communication = () => {
  const AppStore = getStore('appStore');
  const ExamSessionStore = getStore('examSessionStore');
  const journey = useExamSessionStore((state) => state.journey);

  const [isChatVisible, setIsChatVisible] = useState(false);

  useEffect(() => {
    // if they are past waiting for proctor, show chat, otherwise do not show chat...
    setIsChatVisible(!ExamSessionStore.isJourneyStepUnfinished('WaitingForProctor'));
  }, [journey]);

  const sessionDetailsHeight = useLayoutStore(
    (state) => state.containers.sessionDetails.size.height
  );

  const controls = {
    chat: !!AppStore.enabledComponents?.chat,
    microphone: !!AppStore.enabledComponents?.microphone,
    screenShare: !!AppStore.enabledComponents?.screenShare,
    camera: !!AppStore.enabledComponents?.camera,
    leave: !!AppStore.enabledComponents?.leave,
    settings: !!AppStore.enabledComponents?.settings,
  };

  if (!isChatVisible) {
    return (
      <Alert variant="success" size="small">
        Chat will be enabled as soon as checkin has started. Click the check-in option and begin the check-in process to start chatting.
      </Alert>
    );
  }

  return (
    <Flex as="div" height="100%" >
      <Flex.Item
        as="div"
        width="100%"
        height="100%"
        maxWidth="650px"
        align="start"
        padding="none small none none"
        position="relative"
      >
        <Card>
          <Card.Header
            background="brand"
            padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
          >
            <Card.Title>
              <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>Chat</Text>
            </Card.Title>
          </Card.Header>
          <Card.Body height="calc(100% - 30px)">
            <Chat />
          </Card.Body>
        </Card>
      </Flex.Item>
      {/* 
      <Flex.Item as="div" shouldGrow width="55%" align="start">
        {canHaveLiveVideo && isRoomConnected && (
          <RoomContext.Provider value={AppStore.room}>
            <ControlBar
              controls={controls}
              microphoneEnabledLabel="End Voice Call"
              microphoneDisabledLabel="Start Voice Call"
              cameraEnabledLabel="Camera"
              cameraDisabledLabel="Camera"
              screenShareEnabledLabel="Share screen"
              screenShareDisabledLabel="Stop screen share"
            />
          </RoomContext.Provider>
        )}
      </Flex.Item>
      */}
    </Flex>
  );
};

export default Communication;
